import React from "react";
import { Card, Avatar, Typography, Tag, Tooltip, Popconfirm } from "antd"; // Quitamos Space
import { useTranslation } from "react-i18next";
import {
  UserOutlined,
  EditOutlined,
  DeleteOutlined,
  ManOutlined,
  WomanOutlined,
  // Quitamos MedicineBoxOutlined
} from "@ant-design/icons";

const { Meta } = Card;
const { Text } = Typography;

export function PatientCard({ patient, onEdit, onDelete }) {
  // Dos namespaces: el de la institucion y el comun, que ya trae "Editar",
  // "Cancelar" y el "Si, eliminar" de las confirmaciones.
  const { t } = useTranslation(["institution", "common"]);

  const fullName = `${patient.name} ${patient.surname}`;

  const genderIcon =
    patient.sexo === "M" ? (
      <ManOutlined />
    ) : patient.sexo === "F" ? (
      <WomanOutlined />
    ) : (
      <UserOutlined />
    );
  const genderColor =
    patient.sexo === "M"
      ? "blue"
      : patient.sexo === "F"
        ? "magenta"
        : "default";

  // Devuelve null —no "?"— cuando no hay fecha: quien pinta decide como se
  // dice "no lo se" en cada idioma, y aqui solo se calcula.
  const calcularEdad = (birthdate) => {
    if (!birthdate) return null;
    const nacimiento = new Date(birthdate).getTime();
    if (Number.isNaN(nacimiento)) return null;
    const diff = Date.now() - nacimiento;
    if (diff < 0) return null;
    return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
  };

  const edad = calcularEdad(patient.birthdate);

  return (
    <Card
      hoverable
      style={{ borderRadius: 12, overflow: "hidden" }}
      actions={[
        <Tooltip title={t("common:actions.edit")}>
          <EditOutlined key="edit" onClick={() => onEdit(patient)} />
        </Tooltip>,
        <Popconfirm
          title={t("patients.card.deleteTitle")}
          // El nombre va dentro de la frase: en frances la construccion es
          // otra ("la suppression de X"), no se puede pegar por fuera.
          description={t("patients.card.deleteConfirm", {
            nombre: patient.name,
          })}
          onConfirm={() => onDelete(patient)}
          okText={t("common:confirm.yes")}
          cancelText={t("common:actions.cancel")}
          okButtonProps={{ danger: true }}
        >
          <DeleteOutlined key="delete" style={{ color: "#ff4d4f" }} />
        </Popconfirm>,
      ]}
    >
      <div style={{ position: "absolute", top: 12, right: 12 }}>
        {/*
          Contador, no cadena: en frances el CERO va en singular ("0 an") al
          reves que aqui. Y sin fecha de nacimiento se pinta la raya, no el
          "? años" que salia antes.
        */}
        <Tag color={genderColor} icon={genderIcon}>
          {edad === null
            ? t("common:contadores.edadDesconocida")
            : t("common:contadores.anios", { count: edad })}
        </Tag>
      </div>

      <Meta
        avatar={
          <Avatar
            src={patient.avatar}
            size={64}
            icon={<UserOutlined />}
            style={{ backgroundColor: "#87d068" }}
          />
        }
        title={<span style={{ fontSize: 16 }}>{fullName}</span>}
        description={
          <div style={{ marginTop: 8 }}>
            <div style={{ marginBottom: 8 }}>
              <Text type="secondary" style={{ fontSize: 12 }}>
                {t("patients.card.assignedTherapists")}
              </Text>
            </div>

            {patient.terapeutas && patient.terapeutas.length > 0 ? (
              <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                {patient.terapeutas.slice(0, 3).map((t) => (
                  <Tag
                    key={t._id}
                    color="cyan"
                    style={{ margin: 0, fontSize: 10 }}
                  >
                    {t.firstname}
                  </Tag>
                ))}
                {patient.terapeutas.length > 3 && (
                  <Tag style={{ margin: 0, fontSize: 10 }}>
                    +{patient.terapeutas.length - 3}
                  </Tag>
                )}
              </div>
            ) : (
              <Text type="secondary" italic style={{ fontSize: 12 }}>
                {t("patients.card.unassigned")}
              </Text>
            )}
          </div>
        }
      />
    </Card>
  );
}
